import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Column } from '@app/modules/table/classes/column.class';

export class DateCreatedColumn extends Column {
    title = 'table.departments.dateCreated';
    property = 'createdAt';
    type: CellDisplay = CellDisplay.date;
}
